import { render, staticRenderFns } from "./rider-edit-info.vue?vue&type=template&id=48c5fe84&scoped=true&"
import script from "./rider-edit-info.vue?vue&type=script&lang=js&"
export * from "./rider-edit-info.vue?vue&type=script&lang=js&"
import style0 from "./rider-edit-info.vue?vue&type=style&index=0&id=48c5fe84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c5fe84",
  null
  
)

export default component.exports